import React, { useEffect, useState } from 'react';
import { pmApi } from '../../lib/pmApi';
import { useAuth } from '../../contexts/AuthContext';
import AppearancePanel from '../../components/AppearancePanel';
import { useTheme } from '../../contexts/ThemeContext';

const PmProfile = () => {
  const { user, logout } = useAuth();
  const { canToggle: canTheme } = useTheme();
  const [meta, setMeta] = useState(null);

  useEffect(() => { pmApi.me().then(setMeta).catch(() => {}); }, []);

  return (
    <div data-testid="pm-profile-page" className="p-6 max-w-3xl space-y-6">
      <div>
        <p className="text-[#D4AF37] text-xs font-bold tracking-[0.3em] mb-1">PROFILE</p>
        <h1 className="font-['Outfit'] text-3xl font-bold text-white">My Profile</h1>
      </div>
      <div className="bg-[#141414] border border-[#262626] rounded-md p-5 space-y-3 text-sm">
        <p className="text-[#A3A3A3]">Name: <span className="text-white">{user?.name}</span></p>
        <p className="text-[#A3A3A3]">Email: <span className="text-white">{user?.email}</span></p>
        <p className="text-[#A3A3A3]">Role: <span className="text-white capitalize">{(user?.role || '').replace(/_/g, ' ')}</span></p>
        {meta?.company && <p className="text-[#A3A3A3]">Company: <span className="text-white">{meta.company.name}</span></p>}
        {meta?.accessible_property_ids && <p className="text-[#A3A3A3]">Assigned properties: <span className="text-white">{meta.accessible_property_ids.length}</span></p>}
      </div>
      {canTheme && (
        <div className="space-y-3">
          <h2 className="font-['Outfit'] text-xl text-white">Appearance</h2>
          <AppearancePanel />
        </div>
      )}
      <button data-testid="pm-logout-btn" onClick={logout} className="px-4 py-2 bg-[#262626] text-white rounded hover:bg-[#3f3f3f] text-sm">Sign out</button>
    </div>
  );
};

export default PmProfile;
